import { render, staticRenderFns } from "./inputTokenModal.vue?vue&type=template&id=ea4c6286&scoped=true"
import script from "./inputTokenModal.vue?vue&type=script&lang=js"
export * from "./inputTokenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4c6286",
  null
  
)

export default component.exports